import { post } from "../../service/api";

const CreateInvoiceQpay = async (id) => {
    try {
        const response = await post(`/invoice/${id}/createQpay`);
        return response;
    } catch (error) {
        console.error('Error CreateInvoiceQpay:', error);
        throw error;
    }
};

export default CreateInvoiceQpay;